import { useLocation } from 'react-router'

import { useGrowthBook } from '@growthbook/growthbook-react'

import { usePageProps } from '../../../usePageProps'

export const LaptopHelperPages = [
  '/reviews/laptops',
  '/l/computing/laptops',
  '/reviews/laptops/article/how-to-buy-the-best-laptop-aNXXi9d9wmfn',
  '/reviews/laptops/article/top-laptops-by-type/best-windows-laptops-ajKon3C9jxLz',
  '/reviews/laptops/article/best-cheap-laptops-aLsgM2F0QHcg',
  '/reviews/laptops/article/laptops-for-students-aafOE6Y2pcyL',
  '/reviews/laptops/article/top-laptops-by-type/best-chromebooks-a02kZ9W0KQF4',
  '/reviews/laptops/article/top-laptops-by-type/best-macbooks-abjug7l18D2R',
  '/reviews/laptops/article/most-reliable-laptop-brands-akQtM7w0zvuR',
  '/reviews/laptops/article/which-dont-buy-laptops-aOujr8Q4IiPx',
  '/reviews/laptops/article/best-laptop-deals-a0gLg0i9nmhc',
  '/reviews/laptops/article/top-laptops-by-type/mac-vs-pc-vs-chromebook-how-to-choose-the-right-laptop-aacuu8i4xyVQ',
  '/reviews/laptops/article/how-we-test-laptops-arGXp0K3GO9v',
  '/reviews/laptops/article/how-to-speed-up-a-slow-computer-aKcRy8S1oufr',
]

export const useShouldShowLaptopHelper = () => {
  const location = useLocation()
  const { userAccessState } = usePageProps()

  const growthbook = useGrowthBook()
  const validPath = LaptopHelperPages.includes(location.pathname)
  const hasFullAccess =
    userAccessState != null &&
    ['AUTHENTICATED_FULL_ACCESS', 'FULL_ACCESS'].includes(
      userAccessState.transformTypeDecision ?? ''
    )
  if (validPath && hasFullAccess) {
    return growthbook.isOn('DSP-032-guided-purchase-laptop-helper')
  } else {
    return false
  }
}
